import { useMemo } from 'react';

import {
  useGetChatCountByCcEmailDataLazyQuery,
  GetChatCountByCcEmailDataQuery,
  ChatCountByCcEmailReportFragmentFragment,
} from '../../../generated';

export const isGetChatCountByCcEmailReportFragment = (
  data: GetChatCountByCcEmailDataQuery['getChatCountByCCEmail'] | undefined
): data is ChatCountByCcEmailReportFragmentFragment => {
  return data?.__typename === 'GetChatCountByCCEmailReport';
};

export const useGetChatCountByCCEmail = () => {
  const [getChatCountByCCEmail, { data, error, loading }] =
    useGetChatCountByCcEmailDataLazyQuery({
      fetchPolicy: 'network-only',
    });

  const isLoading = loading || (!data && !error);

  const numberOfChats: number | null = useMemo(() => {
    const chatCountByCCEmail = data?.getChatCountByCCEmail;

    if (!isGetChatCountByCcEmailReportFragment(chatCountByCCEmail)) return null;

    return chatCountByCCEmail.numberOfChats;
  }, [data]);

  return {
    numberOfChats,
    error,
    loading: isLoading,
    getChatCountByCCEmail,
  };
};
